/* Vøggan collection page: "show more" for long filter lists, and keeping the
   quick filters in step when Concept updates the page by AJAX. */
(function () {
  'use strict';

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-vm-more]');
    if (!button) return;
    var list = button.previousElementSibling;
    if (!list) return;
    list.querySelectorAll('[data-vm-extra]').forEach(function (li) {
      li.hidden = false;
    });
    button.remove();
  });

  function syncFromResponse(payload) {
    if (!payload || !payload.parsedHTML) return;
    ['VoggQuickFilters'].forEach(function (id) {
      var current = document.getElementById(id);
      var next = payload.parsedHTML.getElementById(id);
      if (current && next) current.innerHTML = next.innerHTML;
    });
  }

  function subscribe() {
    if (!window.theme || !theme.pubsub || !theme.pubsub.PUB_SUB_EVENTS) return;
    theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.facetUpdate, syncFromResponse);
  }

  // This file loads before theme.js (both deferred), so theme.pubsub only
  // exists once the document has finished parsing.
  if (window.theme && window.theme.pubsub) {
    subscribe();
  } else {
    document.addEventListener('DOMContentLoaded', subscribe);
  }
})();
